import { PopupState, usePopupState } from 'material-ui-popup-state/hooks'

const useMobileMenu = (): PopupState => {
  const popupState = usePopupState({ variant: 'popper', popupId: 'mobileMenu' })

  return popupState
}

export default useMobileMenu
